import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TimelineComponent } from './timeline/timeline.component';
import { ContractSelectorComponent } from './contract-selector/contract-selector.component';
import { ModalComponent } from './modal/modal.component';
import { CreateProgramComponent } from './create-program/create-program.component';
import { SearchComponent } from './search/search.component';
import { CreateContractComponent } from './create-contract/create-contract.component';
import { ChartsModule } from '../charts/charts.module';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { ContractStageComponent } from './contract-stage/contract-stage.component';
import { TimeAgoPipe } from './time-ago-pipe/time-ago.pipe';
import { ContractPresentToMarketComponent } from './contract-present-to-market/contract-present-to-market.component';
import { CreateContractLayerComponent } from './create-contract-layer/create-contract-layer.component';
import { HttpClientModule } from '@angular/common/http';
import { ContractMarketQuoteComponent } from './contract-market-quote/contract-market-quote.component';
import { CreateMarketComponent } from './create-market/create-market.component';
import {  MatSidenavModule } from '@angular/material';
import { ContractQuoteStructureAddComponent } from './contract-quote-structure-add/contract-quote-structure-add.component';
import { FiltersComponent } from './filters/filters.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ChartsModule,
    AngularEditorModule,
    HttpClientModule,
    MatSidenavModule
  ],
  declarations: [
    TimelineComponent,
    ContractSelectorComponent,
    ModalComponent,
    CreateProgramComponent,
    CreateContractComponent,
    SearchComponent,
    ContractStageComponent,
    ContractPresentToMarketComponent,
    TimeAgoPipe,
    CreateContractLayerComponent,
    ContractMarketQuoteComponent,
    CreateMarketComponent,
    ContractQuoteStructureAddComponent,
    FiltersComponent
  ],
  entryComponents : [
    ModalComponent,
    CreateProgramComponent,
    CreateContractComponent,
    ContractPresentToMarketComponent,
    CreateContractLayerComponent,
    ContractMarketQuoteComponent,
    CreateMarketComponent,
    ContractQuoteStructureAddComponent
  ],
  exports: [
    TimelineComponent,
    FiltersComponent,
    ContractSelectorComponent,
    ModalComponent,
    CreateProgramComponent,
    CreateContractComponent,
    SearchComponent,
    ContractPresentToMarketComponent,
    ContractMarketQuoteComponent,
    CreateMarketComponent,
    TimeAgoPipe
  ]
})
export class SharedModule { }
